import { FC } from 'react';
import { Box } from '@mui/material';
import Menu from '@/components/menu';
import { SavedFilterItem } from '@/lib/saved-filters';
import { createUseStyles } from 'react-jss';
import { SegmentField } from '../../segment-field';
import ViewMenuItem from './view-menu-item';

interface Props {
  savedFilters: SavedFilterItem[];
  activeSavedFilterId?: string;
  hasActiveFilters?: boolean;
  onApplyFilter: (filterId: string) => void;
  onClearFilter: () => void;
}

const useStyles = createUseStyles({
  trigger: {
    width: '100%',
    minWidth: 200,
  },
});

const ViewSelector: FC<Props> = ({
  savedFilters,
  activeSavedFilterId = '',
  hasActiveFilters = false,
  onApplyFilter,
  onClearFilter,
}) => {
  const styles = useStyles();
  const activeSavedFilter = savedFilters.find(({ id }) => id === activeSavedFilterId) || null;
  const hasActiveSavedFilter = !!activeSavedFilter;
  const showClear = hasActiveSavedFilter || hasActiveFilters;
  let rightValue = 'All Events';
  if (hasActiveSavedFilter) {
    rightValue = activeSavedFilter.name;
  } else if (hasActiveFilters) {
    rightValue = 'Filtered Events';
  }

  return (
    <Menu
      menuId="view-selector-menu"
      trigger={
        <SegmentField
          className={styles.trigger}
          leftLabel="View"
          leftActive={hasActiveSavedFilter}
          rightValue={rightValue}
          onClear={showClear ? onClearFilter : undefined}
        />
      }
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      <Box width={280}>
        {savedFilters.map((savedFilter) => (
          <ViewMenuItem key={savedFilter.id} savedFilter={savedFilter} onApply={onApplyFilter} />
        ))}
      </Box>
    </Menu>
  );
};

export default ViewSelector;
